<template>
    <div>
        <el-button @click="click" style="width:40px;height:40px;" :style="{ backgroundColor: color,color:'white' }"
            circle>{{ dic[k] }}</el-button>
    </div>
</template>
<script>
export default {
    name: "switch-button",
    props: {
        dic: Object,
        k: String
    },
    data: () => {
        return {
            color: "#dfe4e9",
            dicColor: {
                '0': "#dfe4e9",
                '-1': "#5a7286",
                '1': "#edb262",
            }
        }
    },
    created() {
        this.color = this.dicColor[this.dic[this.k]];
    },
    methods: {
        click() {
            let v = this.dic[this.k];
            if (v < 1)
                v = parseInt(v) + 1;
            else
                v = -1;
            this.color = this.dicColor[v.toString()];
            this.$emit('change', v);
        }
    }
}
</script>